import { ACTIONABLE_WAIT_SUB_STATUSES } from 'utils/constants';

/** Status used for action permission checks; may differ from DB status when sub_status implies waiting. */
export function resolveEffectiveStatusForActions(originalStatus: string, subStatus: string | undefined | null): string | undefined {
  const sub_status = subStatus?.toLowerCase();
  if (sub_status != null && ACTIONABLE_WAIT_SUB_STATUSES.includes(sub_status)) {
    return 'waiting';
  }
  return originalStatus.toLowerCase();
}

export function canOpenUnblockNodeInstanceDialog(nodeInstance: any): boolean {
  const status = String(nodeInstance?.originalStatus ?? nodeInstance?.status ?? '').toLowerCase();
  const subStatus = String(nodeInstance?.sub_status ?? '').toLowerCase();
  if (subStatus === 'queuewait' || subStatus === 'lockwait') {
    return false;
  }

  const scheduledStartMs = nodeInstance?.scheduled_start_datetime ? new Date(nodeInstance.scheduled_start_datetime).getTime() : NaN;
  const runNow = nodeInstance?.run_now === true || String(nodeInstance?.run_now).toLowerCase() === 'true';
  const hasFutureScheduledRunTime = !runNow && Number.isFinite(scheduledStartMs) && scheduledStartMs > Date.now();

  return status === 'waiting' || status === 'eventwait' || (status === 'scheduled' && hasFutureScheduledRunTime);
}
